import React from 'react';
import elasticsearch from 'elasticsearch';
import bodybuilder from 'bodybuilder';
import bbox from '@turf/bbox';

import settings from '../helpers/settings';
import CustomMap from './CustomMap';

const adjustBounds = ([Xlen, Ylen], [minX, minY, maxX, maxY]) => {
  const Xcenter = (maxX + minX) / 2;
  const Ycenter = (maxY + minY) / 2;
  const halfX = Xlen / 2;
  const halfY = Ylen / 2;

  return [
    [Ycenter - halfY, Xcenter - halfX],
    [Ycenter + halfY, Xcenter + halfX],
  ];
};

const client = new elasticsearch.Client({
  host: settings.ELASTICSEARCH_HOST,
  // log: 'trace',
});

const ZoneMap = props => {
  const [geojson, setGeojson] = React.useState(undefined);
  const [bounds, setBounds] = React.useState(undefined);

  const { zone, extent, color } = props;

  const getData = React.useCallback(() => {
    if (!zone) {
      return;
    }

    const msearch = {
      body: [
        { index: 'zae' },
        bodybuilder()
          .filter('term', 'id_eae', zone.id_eae)
          .size(9999)
          .rawOption('_source', { include: ['geom', 'layer', 'siret'] })
          .build(),

        { index: 'etablissements' },
        bodybuilder()
          .filter('term', 'id_eae', zone.id_eae)
          .rawOption('_source', { include: ['geom', 'layer', 'siret'] })
          .size(9999)
          .build(),
      ],
    };

    client.msearch(
      msearch,
      (error, { responses: [{ hits: { hits: hitsZae } }, { hits: { hits: hitsEtab } }] }) => {
        const features = [...hitsZae, ...hitsEtab]
          .map(({ _source: { geom: geometry, ...properties } }) => ({
            type: 'Feature',
            properties,
            geometry,
          }));

        const newGeojson = {
          type: 'FeatureCollection',
          features,
        };

        const box = bbox(newGeojson);
        const [minX, minY, maxX, maxY] = box;

        const newBounds = extent
          ? adjustBounds(extent, box)
          : [[minY, minX], [maxY, maxX]];

        setGeojson(newGeojson);
        setBounds(newBounds);
      },
    );
  }, [extent, zone]);

  React.useEffect(() => getData(), [getData]);

  return (
    <CustomMap
      geojson={geojson}
      bounds={bounds}
      color={color}
    />
  );
};

export default ZoneMap;
